export enum FetchStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCEEDED = 'succeeded',
  NOT_FOUND = 'notfound',
  FAILED = 'failed',
}
